module.exports = {
  MDSStreamingAPI: "",
  MDSSnapshotAPI: "wss://tpmds1.aastocks.com/snapshot/pubsub",
  MDSOthersAPI: "wss://tpmds1.aastocks.com/info/pubsub",
  MDSProxyAPI: "wss://trade.sdicsi.com.hk/streaming/pubsub",
  MDSEntityKey: "EIF",
  MDSSuperkey: "eifhk2txtechPkeyencrypt20key1022",
};
